<template>
    <footer class="footer" v-if="$store.state.footer">
        <div class="page-inner">
            <div class="top">
                <div class="logo">
                    <router-link to="/" class="link" title="back to home">
                        <svg viewBox="0 0 588 588">
                        <rect x="305.9" y="277.4" width="282.1" height="4.8"/>
                        <polygon points="463,32.1 463,250 588,250 588,254.8 458.2,254.8 458.2,27.3 588,27.3 588,32.1 "/>
                        <polygon points="449.3,263.7 588,263.7 588,268.5 305.9,268.5 305.9,263.7 444.6,263.7 444.6,18.4 305.9,18.4 305.9,13.7 588,13.7 588,18.4 449.3,18.4 "/>
                        <polygon points="435.6,27.3 435.6,254.8 305.9,254.8 305.9,250 430.9,250 430.9,32.1 305.9,32.1 305.9,27.3 "/>
                        <rect x="305.9" width="282.1" height="4.8"/>
                        <polygon points="18.4,0 18.4,0 18.4,0 "/>
                        <rect width="4.8" height="282.1"/>
                        <polygon points="268.5,0 268.5,282.1 263.7,282.1 263.7,11.7 143.7,281.5 143.4,282.1 138.7,282.1 138.5,281.5 18.4,11.7 18.4,282.1 13.7,282.1 13.7,0 18.4,0 18.4,0 141.1,275.7 263.7,0 263.7,0 "/>
                        <polygon points="27.3,53.6 27.3,282.1 32.1,282.1 32.1,76 123.8,282.1 129,282.1 32.1,64.3 "/>
                        <polygon points="254,0 143.7,247.9 141.1,253.7 138.5,247.9 28.2,0 33.4,0 141.1,242.1 248.8,0 "/>
                        <polygon points="263.7,0 263.7,0 263.7,0 "/>
                        <rect x="277.4" width="4.8" height="282.1"/>
                        <polygon points="254.8,53.6 254.8,282.1 250,282.1 250,76 158.3,282.1 153.1,282.1 250,64.3 "/>
                        <polygon points="18.4,305.9 18.4,305.9 18.4,305.9 "/>
                        <rect y="305.9" width="4.8" height="282.1"/>
                        <polygon points="268.5,305.9 268.5,588 263.7,588 263.7,317.6 143.7,587.4 143.4,588 138.7,588 138.5,587.4 18.4,317.6 18.4,588 13.7,588 13.7,305.9 18.4,305.9 18.4,305.9 141.1,581.5 263.7,305.9 263.7,305.9 "/>
                        <polygon points="27.3,359.5 27.3,588 32.1,588 32.1,381.9 123.8,588 129,588 32.1,370.2 "/>
                        <polygon points="254,305.9 143.7,553.8 141.1,559.6 138.5,553.8 28.2,305.9 33.4,305.9 141.1,547.9 248.8,305.9 "/>
                        <polygon points="263.7,305.9 263.7,305.9 263.7,305.9 "/>
                        <rect x="277.4" y="305.9" width="4.8" height="282.1"/>
                        <polygon points="254.8,359.5 254.8,588 250,588 250,381.9 158.3,588 153.1,588 250,370.2 "/>
                        <polygon points="429.6,305.9 305.9,588 311.1,588 434.8,305.9 "/>
                        <polygon points="464.3,305.9 588,588 582.8,588 459.1,305.9 "/>
                        <path d="M396.1,462.1L447,346.1l50.8,115.9H396.1z M503,462.1l-53.4-121.9l-2.6-5.9l-2.6,5.9l-53.4,121.9l-2.1,4.8H505L503,462.1z"/>
                        <path d="M375.2,475.7L447,312.1l71.7,163.6H375.2z M526,480.5l-2.1-4.8l-74.3-169.5l-0.1-0.3h-4.9l-0.1,0.3L370,475.7l-2.1,4.8 L320.8,588h5.2l47.1-107.5h147.6L567.9,588h5.2L526,480.5z"/>
                        <polygon points="558.2,588 553,588 511.8,494.2 382.1,494.2 340.9,588 335.7,588 376.9,494.2 379,489.4 514.9,489.4 517,494.2 "/>
                        </svg>
                    </router-link>
                </div>
                <div class="text">
                    <div v-html="$store.state.footer.left_content"></div>
                    <div class="back-top">
                        <span @click="backTop">↑ Back to top</span>
                    </div>
                </div>
            </div>
                


            <div class="bottom">
                <ul>
                    <li v-for="(item, index) in $store.state.footer.logos" :key="index">
                        <Link class="img" v-if="item.link" :post_link="item.link"><img :src="item.logo.url"></Link>
                        <span class="img" v-else :post_link="item.link"><img :src="item.logo.url"></span>
                    </li>
                </ul>

                <ul>
                    <li v-for="(item, index) in $store.state.footer.links" :key="index">
                        <Link v-if="item.link" :post_link="item.link" v-html="item.text" />
                    </li>
                </ul>

            </div>
        </div>


    </footer>
</template>

<script>
// import '@/assets/svg/logo.svg?sprite';
// import '@/assets/svg/instagram.svg?sprite';
// import '@/assets/svg/facebook.svg?sprite';
// import '@/assets/svg/twitter.svg?sprite';

import Link from '@/components/ui/Link.vue';


export default {
    name: 'site-footer',

    components: {
        Link,
    },

    // data() {
    //     return {
    //         data: false,
    //     }
    // },

    methods: {
        backTop() {
            this.$smoothScroll({
                scrollTo: window.document.body,
                duration: 500,
            });
        },
    },

    // mounted() {
    //     this.$ajax.get('/footer').then(res => {
    //         this.data = res.data;
    //         // res.data.items.forEach(function(item){
    //         //     item.url = item.url.replace(window.globals.home_url, '')
    //         // })
    //     });
    // },
}
</script>
<style lang="scss">
    .footer {
        padding: 0;
        background: white;
        opacity: 0;
        transition: opacity .3s;

        @at-root {
            @media only screen and (max-width: 767px) {
                html & {
                    opacity: 1;
                }
            }

            body.woocommerce-page &,
            html.end & {
                opacity: 1;
            }
            
        }
        
        .page-inner {
            position: relative;
            z-index: 9;
            overflow: hidden;
        }



        .top {
            display: flex;
            width: 100%;
            box-sizing: border-box;

            & > div {
                padding: var(--padding);
                width: 50%;
                box-sizing: border-box;
                display: grid;
                grid-template-columns: 100%;
            }

            .logo {

                svg {
                    width: 75%;
                    display: block;
                }
            }

            .text {
                font-size: var(--large-size);
                p {
                    margin-bottom: 1em;
                }
            }

            .back-top {
                display: flex;
                align-items: flex-end;
                padding: var(--padding-50) 0;

                span {
                    cursor: pointer;
                    &:hover {
                        text-decoration: underline;
                    }
                }
            }

        }

        .bottom {
            display: flex;
            align-items: center;
            padding: var(--padding-x2) 0 var(--padding);

            ul {
                display: flex;
                align-items: center;
                font-size: var(--small-size);

                &:first-child {
                    flex: 1;
                }

                &:nth-child(2) {
                    padding-right: calc(var(--padding-25) + var(--padding-50));
                    li {
                        padding: 0 var(--padding-25);
                    }
                }
            }


            li {
                padding: 0 var(--padding-50);
            }

            .img {
                position: relative;
                width: 16rem;
                display: block;

                &::before {
                    content: '';
                    padding: 0 0 35%;
                    display: block;
                }

                img {
                    display: block;
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    left: 0;
                    top: 0;
                }
            }
        }
        

    }

    @media only screen and (max-width: 767px) {
        .footer {

            .top {
                display: block;
                width: 100%;
                box-sizing: border-box;

 
                .logo {
                    width: 50%;

                    svg {
                        width: 100%;
                        top: 1rem;
                        position: relative;
                    }
                }

                .text {
                    width: 100%;
                }

                .back-top {
                    padding: var(--padding) 0 0;
                }

            }

            .bottom {
                display: block;


                ul {
   

                    &:nth-child(2) {
                        padding-top: var(--padding);



                        li {
                            padding: 0 0 0 var(--padding);
                            font-size: var(--large-size);
                        }
                    }
                }
                .img {
                    width: 20rem;
                }
            }
            

        }
    }
</style>